export default __webpack_public_path__ + "static/media/9.56facf4e.png";